import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";


// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";

import Parallax from "components/Parallax/Parallax.jsx";

import {navigate} from 'gatsby'


import MemberLevels from '../../components/MemberLevels/MemberLevels'
import MemberShowcase from '../../components/MemberShowcase/MemberShowcase'
import NewMember from '../../components/NewMember/NewMember'

import profilePageStyle from "assets/jss/material-kit-react/views/profilePage.jsx";

import firebase from "gatsby-plugin-firebase"
import "firebase/auth";
import "firebase/database"

import { useObject } from 'react-firebase-hooks/database';


const ProfilePage = (props) => {
  const [value, loadingData, error] = useObject(firebase.database().ref('Members/' + props.userID));
  const [user, setUser] = React.useState(props.User)
  const [afterHours, setClosed] = React.useState(new Date().getHours())


  

  const deleteAccount = () => {
    firebase.auth().currentUser.delete();
  }

  const logout = () => {
    firebase.auth().signOut();
  }

  const profileHolder = "https://firebasestorage.googleapis.com/v0/b/rooftop-420.appspot.com/o/images%2FprofileHolder.png?alt=media&token=d8f8dd01-77e1-4914-a1a1-0d1a35be170a";


  const { classes, ...rest } = props;
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );

  const changePP = (e) => {
    e.preventDefault();
   
    var file = e.target.files[0];

    var db = firebase.database();

    var storageRef = firebase.storage().ref();

    var memberRef = storageRef.child("/MemberProfiles/" + user.uid + "/ProfilePicture/");
    var imageRef = memberRef.child(file.name)
    var Member = db.ref('/Members/' + user.uid);
    imageRef.put(file).then((snapshot) => {
        
        snapshot.ref.getDownloadURL().then(url => { Member.update({profileURL: url}) })
        console.log(`File ${file.name} uploaded!`)
    }).finally();
    
}

  
  if (loadingData) {
    return (
      <div>
        <Header
          color="transparent"
          brand="Material Kit React"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "white"
          }}
          {...rest}
        />
        <Parallax small filter image={require("assets/img/profile-bg.jpg")} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6}>
                  <h4>Profile loading......</h4>
                </GridItem>
              </GridContainer>


            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
  else {
    const userData = value.val();

    return (
      <div>
        <Header
          color="transparent"
          brand="Material Kit React"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "white"
          }}
          {...rest}
        />
        <Parallax small filter image={require("assets/img/profile-bg.jpg")} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6}>
                  <div className={classes.profile}>
                    <div>
                    <input type="file"
       id="avatar" name="ProfilePic"
       accept="image/png, image/jpeg" hidden={true} onChange={e => changePP(e)}/>
       <label for="avatar">
                      <img src={userData.profileURL !== "" ? userData.profileURL : profileHolder} alt="Profile Picture" className={imageClasses} />
                      </label>
                    </div>
                    <div className={classes.name}>
                      <h3 className={classes.title}>{userData.firstName} {userData.lastName}</h3>                      

                      <GridContainer justify="center">

                        <GridItem xs={12} sm={12} md={6}>
                          <MemberLevels variant="static" points={userData.Points} />
                        </GridItem>
                      </GridContainer>


                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              {userData.New === true ? <NewMember classes={classes} UD={userData} fireUser={user} /> : <MemberShowcase classes={classes} approved={userData.Approved} user={userData} uid={user.uid}/>}
              

              <GridContainer justify="center">
              {userData.Staff && afterHours <= 20 && afterHours >= 10 ? <Button color="primary" size="lg" onClick={() => navigate('/Staff/Dashboard')}>
                  Staff area
                      </Button> :""}
                
                      
                <Button color="primary" size="lg" onClick={() => logout()}>
                  Logout
                      </Button>{ }
                      <Button color="danger" size="lg" onClick={() => deleteAccount()}>
                  Delete acccount
                      </Button>
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

//{userData.New ? <NewMember classes={classes} UD={userData} fireUser={user} /> : <MemberShowcase classes={classes} />}

export default withStyles(profilePageStyle)(ProfilePage);
